import {useParams} from "react-router";
import ProfileContent from "../components/Profile/ProfileContent";
import {ProfileProvider} from "../context/ProfileContext";
import PageTitle from "../components/Title/Responsive/PageTitle/PageTitle";

type RouteParams = {
    username:string,
}

const Profile = () => {
    const {username} = useParams<RouteParams>();

    return (
        <ProfileProvider>
            <PageTitle title={`${username ? username+'\'s ' : ''}Profile`} />
            <ProfileContent username={username ?? ''}/>
        </ProfileProvider>
    )
}

export default Profile;
